<template>
    <v-container>
        <v-dialog v-model="dialog_eliminar" max-width="290">
            <v-card>
                <v-card-title class="headline">
                    {{ $t('msg_delete_attachment') }}
                </v-card-title>

                <v-card-text>
                    {{ $t('msg_eliminar_invitacion_2') }}
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary" @click="dialog_eliminar = false">
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :loading="loading" @click="deleteFile()">
                        {{ $t('Si') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('msg_attachment_table') }}</h2>
        <v-layout align-center justify-center fill-height>
            <!-- <v-card> -->
            <!-- <v-card-title>
                    <span class="headline">Documentación que se mostrara en el formulario de invitaciones</span>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="update = false, openDialog()">Nuevo</v-btn>
                </v-card-title> -->
            <!-- </v-card> -->
            <!-- Dialog -->
            <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on" @click="update = false, openDialog()">
                        + {{ $t('add_attachment') }}
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title class="headline">
                        {{ editedItem.id ? 'Editar' : 'Nuevo' }} Documento
                    </v-card-title>

                    <v-card-text>
                        <v-form ref="form">
                            <v-select :disabled="update" v-model="editedItem.idDocumentation"
                                :items="availableDocumentations" item-text="name" item-value="id" label="Documento"
                                placeholder="Seleccione un documento del catálogo"
                                :error-messages="errores.idDocumentation">
                                <template v-slot:item="data">
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{ data.item.name }}
                                            <v-icon v-if="isOcrSupported(data.item.name)" small color="blue"
                                                class="ml-2" title="Validación automática">verified_user</v-icon>
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </template>
                            </v-select>

                            <v-text-field v-model="editedItem.description" placeholder="Ingrese una descripción"
                                label="Descripción" :error-messages="errores.description"></v-text-field>
                        </v-form>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="closeDialog()">Cancelar</v-btn>
                        <v-btn v-if="!update" color="primary" @click="saveItem()" :loading="loading">Guardar</v-btn>
                        <v-btn v-else color="primary" @click="updateItem()" :loading="loading">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex>
                <v-data-table :headers="headers" :items="items" :loading="loading_data_casetas"
                    :rows-per-page-text="$t('filas_por_pagina')" :rows-per-page-items="[
                        { text: '5', value: 5 },
                        { text: '10', value: 10 },
                        { text: '25', value: 25 },
                        {
                            text: this.$t('todos'),
                            value: -1
                        }]">
                    <template v-slot:items="props">
                        <td class="justify-center layout px-0">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon medium class="mr-2" v-on="on" @click="fill_fields(props.item),
                                        errores = [],
                                        update = true,
                                        dialog = true,
                                        id_update = props.item.id">
                                        edit
                                    </v-icon>
                                </template>
                                <span>{{ $t('modificar') }}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-icon color="red" medium v-on="on"
                                        @click="dialog_eliminar = true, id_update = props.item.id">
                                        delete
                                    </v-icon>
                                </template>
                                <span>{{ $t('eliminar') }}</span>
                            </v-tooltip>
                        </td>
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.description }}</td>
                        <td>
                            <v-chip v-if="isOcrSupported(props.item.name)" small color="blue" text-color="white">
                                <v-avatar class="blue darken-4">
                                    <v-icon small>check</v-icon>
                                </v-avatar>
                                validación automática
                            </v-chip>
                        </td>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                            {{ $t('ningun_resultado_1') }} "{{ search }}" {{ $t('ningun_resultado_2') }}
                        </v-alert>
                    </template>
                    <template v-slot:pageText="props">
                        {{ props.rowsPerPage }}
                        Documentos {{ props.pageStart }} - {{ props.pageStop }} {{ $t('prep_de') }} {{ props.itemsLength
                        }}
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import '@/plugins/axios'
import store from '@/store'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

const FALLBACK_OCR_TYPES = [
    {
        "type_id": "curp",
        "name": "CURP",
        "description": "Constancia de la Clave Única de Registro de Población",
        "fields": ["curp", "nombre", "fecha_inscripcion", "folio", "entidad"]
    },
    {
        "type_id": "rfc",
        "name": "RFC / Constancia de Situación Fiscal",
        "description": "Constancia de Situación Fiscal emitida por el SAT",
        "fields": ["RFC", "razon_social", "nombre_comercial", "regimen_capital", "fecha_inicio", "estatus", "regimen_fiscal", "codigo_postal"]
    },
    {
        "type_id": "dc3",
        "name": "DC-3",
        "description": "Constancia de Competencias o Habilidades Laborales",
        "fields": ["nombre_trabajador", "curp_trabajador", "ocupacion", "puesto", "nombre_empresa", "rfc_empresa", "nombre_curso", "duracion_horas", "fecha_inicio", "fecha_fin", "area_tematica", "agente_capacitador"]
    },
    {
        "type_id": "opinion_cumplimiento",
        "name": "Opinión de Cumplimiento",
        "description": "Opinión del cumplimiento de obligaciones fiscales (32-D)",
        "fields": ["RFC", "razon_social", "sentido", "folio", "fecha_emision", "vigente"]
    },
    {
        "type_id": "cedula_sua",
        "name": "Cédula SUA",
        "description": "Cédula de Determinación de Cuotas del Sistema Único de Autodeterminación",
        "fields": ["registro_patronal", "RFC", "razon_social", "actividad", "bimestre", "fecha_proceso", "delegacion_imss", "subdelegacion_imss", "total_cotizantes", "total_rcv", "total_infonavit"]
    },
    {
        "type_id": "linea_captura_imss",
        "name": "Línea de Captura IMSS",
        "description": "Formato para pago de cuotas obrero patronales del IMSS",
        "fields": ["registro_patronal", "RFC", "razon_social", "delegacion", "subdelegacion", "periodo_imss", "bimestre_rcv", "fecha_limite", "total_pagar", "linea_captura", "folio_sua", "num_cotizantes"]
    }
];

export default {
    data() {
        return {
            loading_data_casetas: false,
            headers: [],
            errores: [],
            items: [],
            documentations: [],
            dialog: false,
            editedItem: {
                id: null,
                idDocumentation: null,
                description: "",
            },
            update: false,
            id_empresa: '',
            dialog_eliminar: false,
            loading: false,
            ocrSupportedTypes: []
        };
    },
    beforeUpdate() {
        this.headers = [
            { text: this.$t('acciones'), align: 'center', value: "actions", sortable: false },
            { text: this.$t('nombre'), value: "name" },
            { text: this.$t('descriptionss'), value: "description" },
            { text: 'Validación', value: 'validation', sortable: false },
        ]
    },
    computed: {
        ...mapState(['language']),
        ...mapGetters(['getProfile']),
        availableDocumentations() {
            if (!this.items || !this.documentations) return [];
            const existingNames = this.items.map(i => i.name);
            return this.documentations.filter(d => !existingNames.includes(d.name));
        }
    },
    mounted() {
        this.fetchDocumentations()
        this.fetchItems()
        this.fetchOcrTypes()
    },

    methods: {
        async fetchDocumentations() {
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/documentations',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.documentations = response.data
                    this.get_extra_data()
                })
                .catch(error => {
                    console.log(error)
                })
        },
        get_extra_data: function () {
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/empresas/administradores/user/' + this.getProfile.id + '/',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.id_empresa = response.data[0].id_empresa
                })
                .catch(error => {
                    console.log(error)
                })
        },
        async fetchItems() {
            this.loading_data_casetas = true
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/documentation/ListCreate/',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.items = response.data
                    this.loading_data_casetas = false
                })
                .catch(error => {
                    this.loading_data_casetas = false
                    console.log(error)
                })
        },
        getDocumentationName(idDoc) {
            const doc = this.documentations.find(d => d.id === idDoc);
            return doc ? doc.name : "";
        },
        openDialog() {
            this.errores = []
            this.editedItem = { id: null, idDocumentation: null, description: "" };
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
            this.$refs.form.resetValidation();
        },
        async saveItem() {
            this.loading = true
            this.errores = []
            const config = {
                method: 'post',
                url: 'https://empresa-service.intrare.app/documentation/ListCreate/',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': this.language,
                    'authorization': 'Token ' + store.getters.getToken
                },
                data: {
                    idCompany: this.id_empresa,
                    idDocumentation: this.editedItem.idDocumentation,
                    description: this.editedItem.description
                }
            };
            axios(config)
                .then(ok => {
                    this.loading = false
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', this.$t('msg_attachment_added'))
                    this.fetchItems()
                    this.dialog = false
                    setTimeout(this.clear, 3000);
                })
                .catch(error => {
                    this.loading = false
                    if (error.response.status == 400
                        && typeof error.response.data == "object"
                        && error.response.data) {
                        this.errores = error.response.data
                        if (error.response.data.non_field_errors)
                            this.errores.idDocumentation = error.response.data.non_field_errors
                    }
                })
        },
        async updateItem() {
            this.loading = true
            this.errores = []
            const config = {
                method: 'patch',
                url: 'https://empresa-service.intrare.app/documentation/Detail&Update&Delete/' + this.editedItem.id + '/',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': this.language,
                    'authorization': 'Token ' + store.getters.getToken
                },
                data: {
                    description: this.editedItem.description
                }
            };
            axios(config)
                .then(ok => {
                    this.loading = false
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', this.$t('msg_attachment_updated'))
                    this.fetchItems()
                    this.dialog = false
                    setTimeout(this.clear, 3000);
                })
                .catch(error => {
                    this.loading = false
                    if (error.response.status == 400
                        && typeof error.response.data == "object"
                        && error.response.data)
                        this.errores = error.response.data
                })
        },
        fill_fields(item) {
            this.editedItem = Object.assign({}, item)
            console.log('valor a editar = ', this.editedItem)
        },
        clear: function () {
            this.errores = []
            this.$store.commit('snackbar_change_color', 'success')
            this.$store.commit('snackbar_activate_false')
        },
        async deleteFile() {
            this.loading = true
            const config = {
                method: 'delete',
                url: 'https://empresa-service.intrare.app/documentation/Detail&Update&Delete/' + this.id_update + '/',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': this.language,
                    'authorization': 'Token ' + store.getters.getToken
                },
            }
            axios(config).then(ok => {
                this.loading = false
                console.log('Archivo con ID = ', this.id_update + ' Eliminado Correctamente.')
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'warning')
                this.$store.commit('snackbar_change_message', this.$t('msg_attachment_deleted'))
                this.fetchItems()
                this.dialog_eliminar = false
                setTimeout(this.clear, 3000)
            })
                .catch(error => {
                    this.loading = false
                    this.dialog_eliminar = false
                    if (error.response.status == 400
                        && typeof error.response.data == "object"
                        && error.response.data)
                        this.errores = error.response.data
                })
        },

        async fetchOcrTypes() {
            try {
                const response = await axios.get('https://microservices.intrare.app/ocr/document/types/');
                if (response.data && Array.isArray(response.data)) {
                    this.ocrSupportedTypes = response.data;
                } else if (response.data && Array.isArray(response.data.types)) {
                    this.ocrSupportedTypes = response.data.types;
                } else {
                    console.warn('Unexpected OCR types format, using fallback.', response.data);
                    this.ocrSupportedTypes = FALLBACK_OCR_TYPES;
                }
            } catch (e) {
                console.error("Error fetching OCR types, using fallback.", e);
                this.ocrSupportedTypes = FALLBACK_OCR_TYPES;
            }
        },
        isOcrSupported(docName) {
            if (!docName || !this.ocrSupportedTypes || this.ocrSupportedTypes.length === 0) return false;

            docName = docName.toLowerCase();
            return this.ocrSupportedTypes.some(type => {
                const typeValue = typeof type === 'string' ? type : (type.type_id || type.type || '');
                const val = typeValue.toLowerCase();

                if (docName.includes(val)) return true;
                if (docName.includes(val.replace(/_/g, ' '))) return true;

                // Alias
                if (val === 'cedula_sua' && docName.includes('sua')) return true;
                if (val === 'linea_captura_imss' && (docName.includes('linea') || docName.includes('captura'))) return true;
                if (val === 'opinion_cumplimiento' && docName.includes('opinion')) return true;

                return false;
            });
        }
    },
};
</script>

<style scoped>
.v-card-title {
    align-items: center;
}
</style>
